import React from 'react';
import { Button, Result } from 'antd';

import { AccountCreateView } from 'components/Account/Create/AccountCreateView';
import { AccountCreateModel } from 'components/Account/Create/AccountCreateModel';
import { Account } from 'models/Account';
import { GlobalStore } from 'stores/Global';
import { isDemo, needsBankConnection } from 'utils/AccountMode';

export const AccountBankingRoute: React.FC<{ account: Account }> = ({ account }) => {
  if (needsBankConnection(account)) {
    const model = new AccountCreateModel({
      step: 1,
      account
    });

    return (
      <AccountCreateView model={model} />
    );
  }

  // Reachable only by direct URL - the Banking menu item is hidden for demo accounts.
  if (isDemo(account)) {
    return (
      <Result
        status="success"
        title="No bank account needed"
        subTitle="This is a demo account. Payments are simulated and never reach Stripe."
        extra={
          <Button type="primary" onClick={() => GlobalStore.navigate('/')}>
            Back Home
          </Button>
        }
      />
    );
  }

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, bank account was already set up."
      extra={
        <Button type="primary" onClick={() => GlobalStore.navigate('/')}>
          Back Home
        </Button>
      }
    />
  );
};